import classNames from 'classnames';
import * as React from 'react';

import {buttonClassName, ButtonClassNameOptions} from './buttonClassName';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, ButtonClassNameOptions {}

export const Button: React.FunctionComponent<ButtonProps> = ({variant, size, block, className, children, ...rest}: ButtonProps) => (
    <button className={classNames(buttonClassName({variant, size, block}), className)} {...rest}>
        {children}
    </button>
);
